/* eslint-disable */
import Config from '@/helpers/config'
import axios from 'axios'
import {
  EventBus
} from "@/helpers/event-bus";

function validateEmail(email) {
  var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
  return re.test(String(email).toLowerCase())
}

function getCache(instance, key, isObject = false) {
  let value = instance.$localStorage.get(key)
  if (!value) {
    return null
  }

  if (isObject) {
    value = JSON.parse(value)
  }

  return value
}

function getAllProducts(instance, params) {
  return new Promise((resolve, reject) => {

    if (typeof (window.CACHE_ALL_PRODUCTS) !== 'undefined') {
      // console.log('get from cache')
      return resolve(window.CACHE_ALL_PRODUCTS)
    }

    requestV2(instance).get(`/products/`, params).then(response => {
      window.CACHE_ALL_PRODUCTS = response.data

      resolve(response.data)
    }, response => {
      reject(response.status)
    })
  })
}

function getAllProductCategories(instance, params) {
  return new Promise((resolve, reject) => {
    getAllProducts(instance, params).then( products =>{
      let categories  = [];
      let list_category_ids = [];
      products.forEach(product=>{
        if (product.category){
          if (list_category_ids.indexOf(product.category.id) == -1 ){
            list_category_ids.push(product.category.id);
            categories.push(product.category);
          }
        }
        categories = categories.sort((n1,n2) => n1.sort_order - n2.sort_order);
        resolve(categories);
        
      })
    });
    
  })
}

function getAllVarriants(instance, params) {
  console.log('before get varriants');
  return new Promise((resolve, reject) => {

    if (typeof (window.CACHE_ALL_VARRIANTS) !== 'undefined') {
      // console.log('get from cache')
      return resolve(window.CACHE_ALL_VARRIANTS)
    }

    request(instance, false, 'salemarket').get('/listVarriants/', { params: params }).then(response => {
      window.CACHE_ALL_VARRIANTS = response.data.data

      resolve(response.data.data)
    }, response => {
      reject(response.status)
    })
  })
}



function getProvinces(instance) {
  return new Promise((resolve, reject) => {

    if (typeof (window.CACHE_ALL_PROVINCES) !== 'undefined') {
      return resolve(window.CACHE_ALL_PROVINCES)
    }

    requestV2(instance).get(`listProvinces`).then(response => {
      // console.log('response',response.data)
      window.CACHE_ALL_PROVINCES = response.data
      resolve(response.data)
    }, response => {
      reject(response.status)
    })
  })
}

function getHeader(instance, required_auth = false, append_header=null) {
  let user = instance.$localStorage.get('user')
  let headers = {
    'Access-Control-Allow-Origin': '*'
  }
  if (user) {
    user = JSON.parse(user)
    headers['Authorization'] = 'Token ' + user.token
  }
  if (append_header){
    for(var key in append_header){
      headers[key] = append_header[key]
    }
  }
  return headers
}

function getRequestUrl(suffix_url = null, version='v1') {

  let result = version == 'v1' ? Config.SERVER: Config.SERVER_V2;
  if (suffix_url) {
    result += '_' + suffix_url
  }

  return result;
}

function request(instance, required_auth = false, suffix_url = null, append_header=null) {
  
  let init_obj = {
    baseURL: getRequestUrl(suffix_url),
    timeout: 20000
  }

  init_obj.headers = getHeader(instance, required_auth, append_header)



  let i = axios.create(init_obj)
  return i
}


function requestV2(instance, required_auth = false, append_header=null) {
  
  let init_obj = {
    baseURL: getRequestUrl(null, 'v2'),
    timeout: 20000,
    // crossDomain: true
  }

  init_obj.headers = getHeader(instance, required_auth, append_header)

  let i = axios.create(init_obj)
  return i
}

function getRequestByPath(instance, path) {
  return new Promise((resolve, reject) => {
    request(instance).get(Config.SERVER + path).then(response => {
      //console.log(response)
      resolve(response.data)
    }).catch(error => {
      reject(error)
    })
  })
}


function showErrorMessage(instance, err_response) {
  console.log('err_response',err_response)
  let message = "";
  if (err_response && err_response.data) {
    if ( typeof(err_response.data) == "string" ){
      message = err_response.data
    }else{
      for (let key in err_response.data) {
        if (key === 'non_field_errors' || key === 'detail') {
          message += err_response.data[key] + '<br/>'
        } else {
          message += key + ': ' + err_response.data[key] + '<br/>'
        }
      }
    }

  } else {
    message = 'There is an error when process'
  }

  instance.$alertify.error(message)
}

function showError(instance, message) {
  instance.$alertify.error(message)
}

function showSuccess(instance, message) {
  instance.$alertify.success(message)
}



function getShortAddress(result, cities) {
  // not include province and country
  let address_components = result.address_components.filter(item => {
    return item.types.indexOf('administrative_area_level_1') === -1 && item.types.indexOf('country') === -1
  })
  let cityId = getCityFromAddress(result, cities)
  let address = address_components.map(item => { return item.long_name }).join(",")
  return {
    address: address,
    cityId: cityId
  }
}

function getGenderLabel(gender) {
  let result = ''
  switch (gender) {
    case 'A':
      result = 'Any'
      break
    case 'F':
      result = 'Female'
      break
    case 'A':
      result = 'Male'
      break
  }
  return result
}

function getInfoFromToken(instance) {
  return new Promise((resolve, reject) => {
    Promise.all([getRequestByPath(instance, '/user/'), getRequestByPath(instance, '/user-profile/')]).then(values => {
      instance.$localStorage.set('user', JSON.stringify(values[0].results[0]))
      instance.$localStorage.set('profile', JSON.stringify(values[1].results[0]))
      resolve({ user: values[0].results[0], profile: values[1].results[0] })
    }, reason => {
      reject()
    })
  })

}

// Send text to clipboard for copy
function sendToClipboard(str) {
  // https://hackernoon.com/copying-text-to-clipboard-with-javascript-df4d4988697f
  const el = document.createElement('textarea')
  el.value = str
  el.setAttribute('readonly', '')
  el.style.position = 'absolute'
  el.style.left = '-9999px'
  document.body.appendChild(el)
  const selected = document.getSelection().rangeCount > 0 ? document.getSelection().getRangeAt(0) : false
  el.select()
  document.execCommand('copy')
  document.body.removeChild(el)
  if (selected) {
    document.getSelection().removeAllRanges()
    document.getSelection().addRange(selected)
  }
}


// Get base url https://www.google.com.vn/search => https://www.google.com.vn
function getBaseUrl() {
  let url = window.location.href
  let arr = url.split('/')
  return arr[0] + '//' + arr[2]
}

// format money
function toCommas(value, separator=',') {
  if (value == null) return 0;
  return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, separator)
}

// function getProfile(instance, profileId){
//   let path = 'user-profile/' + profileId + '/'
//   return new Promise((resolve, reject) => {
//     request(instance).get(Config.SERVER + path).then(response => {
//       //console.log(response)
//       resolve(response.data.results)
//     }).catch( error =>{
//       reject(error)
//     })
//   })
// }
// Turn text to readable url if it is embbed
function urlify(text) {
  var urlRegex = /(https?:\/\/[^\s]+)/g
  return text.replace(urlRegex, function (url) {
    return '<a href="' + url + '" target="blank" >' + url + '</a>'
  })

}

function getCityFromAddress(placeResultData, cities) {
  if (!cities) {
    return null
  }
  // get type = administrative_area_level_1
  let address_components = placeResultData.address_components
  let cityType = address_components.filter(item => { return item.types.indexOf('administrative_area_level_1') !== -1 })

  if (cityType.length > 0) {
    cityType = cityType[0]
    for (let i = 0; i < cities.length; i++) {
      if (cities[i].all_names.indexOf(cityType.short_name) !== -1) {
        return cities[i].id
      }
    }
  }
  return null
}

// Add more from http://en.wikipedia.org/wiki/List_of_file_signatures
function mimeType(headerString) {
  let type = ''
  switch (headerString) {
    case '89504e47':
      type = 'image/png'
      break
    // case '47494638':
    //   type = 'image/gif'
    //   break;
    case 'ffd8ffe0':
    case 'ffd8ffe1':
    case 'ffd8ffe2':
      type = 'image/jpeg'
      break
    default:
      type = 'unknown'
      break
  }
  return type
}

function getTotalPages(total, item_per_page = getLimit()) {
  let page = total / item_per_page
  if (total % item_per_page == 0) {
    return page
  } else {
    return Math.floor(page) + 1
  }
}

//10 item per page
function getNextOffset(page, limit = null) {
  if (limit == null) {
    limit = getLimit()
  }
  return (page - 1) * limit
}

//10 for page
function getLimit() {
  return 10
}

function arrayToRequestParam(arr) {
  let out = []
  for (var key in arr) {
    if (arr.hasOwnProperty(key)) {
      out.push(key + '=' + encodeURIComponent(arr[key]));
    }
  }

  return out.join('&');
}

function serialFormat(seri_number) {
  let missing = 7 - seri_number.length
  if (missing > 0) {
    seri_number = "0".repeat(missing) + seri_number
  }
  return seri_number
}

function fN(number) {
  return number >= 10 ? number : '0' + number
}

function getFormattedTime(instance, date) {

  let now = instance.$moment(); //todays date
  let duration = instance.$moment.duration(now.diff(date));


  let seconds = Math.floor(duration._milliseconds / 1000)
  //24 * 60 * 60 = 86400

  let remain = 86400 - seconds
  if (remain <= 0) {
    return 0
  }

  let hours = Math.floor(remain / 60 / 60)
  let minute = Math.floor((remain - hours * 60 * 60) / 60)
  let second = remain - hours * 60 * 60 - minute * 60
  return fN(hours) + ":" + fN(minute) + ":" + fN(second)

}

function updateDateTime(instance) {
  //console.log('interval');
  if (!instance.list_items) {
    return
  }
  for (let i = 0; i < instance.list_items.length; i++) {
    instance.list_items[i].remain_text = getFormattedTime(instance, instance.list_items[i].add_date)
  }
}

// Get user from local
function getUser(instance) {
  let localUser = instance.$localStorage.get('user')
  if (localUser) {
    return JSON.parse(localUser)
  } else {
    return null
  }
}


function getItemFromListById(list, id) {
  let item = list.filter(item => {
    return item.id == id
  })

  return item.length > 0 ? item[0] : null
}

function arrayToObject(arr) {
  let obj = {}
  arr.forEach(item => {
    obj[item.id] = item.name
  })
  return obj
}

function listRoles() {
  let list = {
    1: 'admin',
    2: 'farmer',
    3: 'system_user',
    4: 'seller'
  }
  return list
}

function getRoleName(role_id) {
  let list = listRoles()
  return list[role_id];
}

// Equivalent jquery params 
function params(a) {
  return Object.keys(a).map(function (k) {
    return encodeURIComponent(k) + '=' + encodeURIComponent(a[k])
  }).join('&')
}

function getFacebookKitUrl(facebook_id, callbackUrl, extra_params = null) {

  console.log('callbackUrl', callbackUrl)
  let FACEBOOK_KIT_URL = 'https://www.accountkit.com/v1.0/basic/dialog/sms_login/?' + 'app_id='
    + facebook_id + '&redirect=' + encodeURIComponent(callbackUrl) + '&fbAppEventsEnabled=true&'
  if (extra_params) {
    FACEBOOK_KIT_URL += params(extra_params)
  }
  return FACEBOOK_KIT_URL;
}
// to save to coookie like name and role
function getPreFacebookKit(precallbackUrl, facebook_kit_link, extra_params) {

  extra_params['facebook_kit_link'] = facebook_kit_link;
  return precallbackUrl + "?" + params(extra_params)
}

function validPhone(mobile) {
  var vnf_regex = /((09|03|07|08|05)+([0-9]{8})\b)/g;

  if (mobile !== '') {
    if (vnf_regex.test(mobile) == false) {
      return false;
    } else {
      return true;
    }
  } else {
    return false;
  }
}

function orderStatus(status) {
  let result = "";
  switch (parseInt(status)) {
    case 0:
      result = "Chưa gửi";
      break;
    case 1:
      result = "Đã Gửi";
      break;
    case 2:
      result = "Đã Xác nhận";
      break;
    case 3:
      result = "Đã chuyển hàng";
      break;
    case 4:
      result = "Hoàn thành";
      break;
  }
  return result;
}

function getStreetType(value){
  let result = "";
  switch (parseInt(value)) {
    case 0:
      result = "Không có";
      break;
    case 1:
      result = "Đất -xe máy";
      break;
    case 2:
      result = "Nhựa -xe máy";
      break;
    case 3:
      result = "Đất -ô tô";
      break;
    case 4:
      result = "Nhựa -ô tô";
      break;
  }
  return result;
  
}


function getCertificateType(value){
  let result = "";
  switch (parseInt(value)) {
    case 0:
      result = "Không có";
      break;
    case 1:
      result = "Sổ xanh";
      break;
    case 2:
      result = "Sổ đỏ";
      break;
   
  }
  return result;
  
}

function getTypeName(instance,type){
  
  return instance.$t(type);
}


function setCookie(name,value,days) {
  var expires = "";
  if (days) {
      var date = new Date();
      date.setTime(date.getTime() + (days*24*60*60*1000));
      expires = "; expires=" + date.toUTCString();
  }
  document.cookie = name + "=" + (value || "")  + expires + "; path=/";
}
function getCookie(name) {
  var nameEQ = name + "=";
  var ca = document.cookie.split(';');
  for(var i=0;i < ca.length;i++) {
      var c = ca[i];
      while (c.charAt(0)==' ') c = c.substring(1,c.length);
      if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length,c.length);
  }
  return null;
}
function eraseCookie(name) {   
  document.cookie = name+'=; Max-Age=-99999999;';  
}

function isMobile(){
  return( navigator.userAgent.match(/Android/i)
  || navigator.userAgent.match(/webOS/i)
  || navigator.userAgent.match(/iPhone/i)
  || navigator.userAgent.match(/iPad/i)
  || navigator.userAgent.match(/iPod/i)
  || navigator.userAgent.match(/BlackBerry/i)
  || navigator.userAgent.match(/Windows Phone/i));
}

function showLoginZalo(type = null){
  var loginZaloUrl = Config.zaloUrl(type);
  // console.log('Utils.isMobile()', Utils.isMobile())

  if (isMobile()) {

    location.href = loginZaloUrl;
  } else {
    window.newwindow = window.open(
      loginZaloUrl,
      "Login",
      "height=500,width=450"
    );
    if (window.focus) {
      window.newwindow.focus();
    }
  }
}

function refreshUser(instance){
  requestV2(instance).get(`profile`).then((response)=>{
    console.log('refresh data',response)
    EventBus.$emit("updateUser", response.data);
    instance.$localStorage.set("user", JSON.stringify(response.data));
  })
}

function formatPayload (value) {
  if (value < 1000) {
    return value + ' kg'
  } else {
    return (value / 1000) + ' tấn'
  }
}

function roundNumber (number) {
  return Math.round(number * 100) / 100
}

function blobToBase64 (blob) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader()
    reader.onloadend = () => resolve(reader.result)
    reader.readAsDataURL(blob)
  })
}


function getAllPlants(instance, params) {
  return new Promise((resolve, reject) => {
    console.log('params',params)
    
    requestV2(instance).get(`/presticide_plans/?is_on_top=1`, params).then(response => {
    
      resolve(response.data)
    }, response => {
      reject(response.status)
    })
  })
}



export default {
  roundNumber: roundNumber,
  validateEmail: validateEmail,
  getCache: getCache,
  getAllProducts: getAllProducts,
  getAllProductCategories: getAllProductCategories,
  getProvinces: getProvinces,
  request: request,
  requestV2: requestV2,
  showErrorMessage: showErrorMessage,
  getGenderLabel: getGenderLabel,
  getRequestByPath: getRequestByPath,
  getInfoFromToken: getInfoFromToken,
  sendToClipboard: sendToClipboard,
  getBaseUrl: getBaseUrl,
  toCommas: toCommas,
  getShortAddress: getShortAddress,
  urlify: urlify,
  getCityFromAddress: getCityFromAddress,
  mimeType: mimeType,
  getTotalPages: getTotalPages,
  getNextOffset: getNextOffset,
  getLimit: getLimit,
  arrayToRequestParam: arrayToRequestParam,
  showError: showError,
  showSuccess: showSuccess,
  serialFormat: serialFormat,
  getHeader: getHeader,
  getFormattedTime: getFormattedTime,
  updateDateTime: updateDateTime,
  getUser: getUser,
  getItemFromListById: getItemFromListById,
  arrayToObject: arrayToObject,
  getAllVarriants: getAllVarriants,
  listRoles: listRoles,
  getRoleName: getRoleName,
  params: params,
  getFacebookKitUrl: getFacebookKitUrl,
  getPreFacebookKit: getPreFacebookKit,
  validPhone: validPhone,
  getRequestUrl: getRequestUrl,
  orderStatus: orderStatus,
  getTypeName: getTypeName,
  setCookie: setCookie,
  getCookie: getCookie,
  isMobile: isMobile,
  getStreetType: getStreetType,
  getCertificateType: getCertificateType,
  showLoginZalo: showLoginZalo,
  refreshUser: refreshUser,
  formatPayload: formatPayload,
  blobToBase64: blobToBase64,
  getAllPlants: getAllPlants
}



// WEBPACK FOOTER //
// ./src/helpers/utils.js